export function map<T>(type: new() => T, obj: Partial<T>): T {
    const item = new type();
    Object.keys(obj).forEach(propertyName => { (item as any)[propertyName] = (obj as any)[propertyName]});
    return item;
}